import {getGoogleMapsApiKeyGWT} from '../../../../_shared/GWTBridge/invoke/genPage';
import {showInfoMessage} from '../../../../_shared/Messages/actions/MessageActions';
import {isDevEnv} from '../../../../utils/platform';

export const getGoogleMapsApiKey = (): string => {
    const isCloud = isDevEnv() || window.location.host.includes('priority-connect');
    const apiKey = isCloud
        ? getGoogleMapsApiKeyFromPriorityParams() || getGoogleMapsApiKeyGWT()
        : getGoogleMapsApiKeyGWT();
    !apiKey && showInfoMessage({content: 'Google Maps API key is missing.'});
    return apiKey;
};

const getGoogleMapsApiKeyFromPriorityParams = () => {
    const name = 'googleapikey';
    const start = (window as any).priorityParams?.indexOf(name);
    if (!start || start === -1) return '';
    const nextParamIndex = (window as any).priorityParams.indexOf('&', start);
    const end = nextParamIndex !== -1 ? nextParamIndex : (window as any).priorityParams.length;
    return (window as any).priorityParams.substring(start + 1 + name.length, end);
};
